import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AttachmentFile, FileUploadResponse } from 'src/app/_Models/fileupload/fileupload';
import { FileContainerList } from 'src/app/components/common/static-data-common';
import { AuthenticationService } from '../user/authentication.service';
import { Observable } from 'rxjs';
import { BlockBlobClient } from '@azure/storage-blob';

@Injectable({ providedIn: 'root' })

export class FileStoreService {


  fileServer: string

  devEnvironment: boolean

  constructor(private http: HttpClient, @Inject('FILE_SERVER_URL') fileServerUrl: string, @Inject('DEV_ENV') devEnv: boolean, private authserve: AuthenticationService) {

    this.fileServer = fileServerUrl;
    this.devEnvironment = devEnv;

    if (this.fileServer.charAt(this.fileServer.length - 1) == '/')
      this.fileServer = this.fileServer.substring(0, this.fileServer.length - 1);
  }

  uploadFiles(cloudContainer, attachedList: Array<AttachmentFile>) {

    if (this.devEnvironment) {
      cloudContainer = FileContainerList.DevContainer
    }

    const formData: FormData = new FormData();

    attachedList.map(x => {

      formData.append('files', x.file, x.uniqueld);

    });

    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');
    var currentUser = this.authserve.getCurrentUser();
    var customerId = currentUser.customerid
    return this.http.post<any>(`${this.fileServer}/api/FileStore/savefile/${cloudContainer}/${customerId}`, formData, { headers: headers })
      .pipe(map(response => {
        return response;
      }));
  }

  uploadFilesWithProgressBar(cloudContainer, attachedList: Array<AttachmentFile>): Observable<any> {
    if (this.devEnvironment) {
      cloudContainer = FileContainerList.DevContainer;
    }
    const formData: FormData = new FormData();
    attachedList.forEach(x => {
      formData.append('files', x.file, x.uniqueld);
    });
    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');
    const currentUser = this.authserve.getCurrentUser();
    const customerId = currentUser.customerid;
    return this.http.post<any>(`${this.fileServer}/api/FileStore/savefile/${cloudContainer}/${customerId}`, formData, {
      headers: headers,
      reportProgress: true,
      observe: 'events'
    })
  }

  uploadLargeFilesWithProgressBar(cloudContainer, attachedList: Array<AttachmentFile>): Observable<any> {
    if (this.devEnvironment) {
      cloudContainer = FileContainerList.DevContainer;
    }
    const formData: FormData = new FormData();
    attachedList.forEach(x => {
      formData.append('files', x.file, x.uniqueld);
    });
    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');
    const currentUser = this.authserve.getCurrentUser();
    const customerId = currentUser.customerid;
    return this.http.post<any>(`${this.fileServer}/api/FileStore/savelargefile/${cloudContainer}/${customerId}`, formData, {
      headers: headers,
      reportProgress: true,
      observe: 'events'
    })
  }
  downloadBlobFile(id, cloudContainer) {
    if (this.devEnvironment) {
      cloudContainer = FileContainerList.DevContainer
    }
    var currentUser = this.authserve.getCurrentUser();
    var customerId = currentUser.customerid
    return this.http.get(`${this.fileServer}/api/FileStore/downloadfile/${id}/${cloudContainer}/${customerId}`, { responseType: 'blob' });
  }
  downloadZip(model: any) {
    if (this.devEnvironment) {
      model.containerId = FileContainerList.DevContainer
    }
    let currentUser = this.authserve.getCurrentUser();
    let customerId = currentUser.customerid;
    model.customerId = customerId;
    const headers = new HttpHeaders({
      'Content-Type': 'application/zip'
    });
    return this.http.post(`${this.fileServer}/api/FileStore/downloadZip`, model, { responseType: 'arraybuffer' });
  }


  async uploadFileData(cloudContainer, attachedList: Array<AttachmentFile>): Promise<FileUploadResponse> {
    if (this.devEnvironment) {
      cloudContainer = FileContainerList.DevContainer
    }

    const formData: FormData = new FormData();

    attachedList.map(x => {

      formData.append('files', x.file, x.uniqueld);

    });

    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');

    var currentUser = this.authserve.getCurrentUser();
    var customerId = currentUser.customerid

    return this.http.post<any>(`${this.fileServer}/api/FileStore/savefile/${cloudContainer}/${customerId}`, formData, { headers: headers })
      .pipe(map(response => {
        return response;
      })).toPromise();

  }

  getContainerId(containerId: number) {
    if (this.devEnvironment) {
      return FileContainerList.DevContainer
    }
    return containerId;
  }


  generateUploadSas(fileName: string, containerId: number): Observable<{ uniqueId: string; blobName: string; uploadUrl: string }> {
    return this.http.post<any>(`${this.fileServer}/api/FileStore/generate-upload-saas`, {
      fileName,
      containerId
    });
  }

  async uploadFileDirectToBlob(
    file: File,
    sasUrl: string,
    onProgress: (percent: number) => void
  ): Promise<void> {
    const blockBlobClient = new BlockBlobClient(sasUrl);
    await blockBlobClient.uploadData(file, {
      blockSize: 8 * 1024 * 1024, // 8MB blocks
      concurrency: 5,
      onProgress: (progress) => {
        const percent = Math.min(Math.round((progress.loadedBytes / file.size) * 100), 99);
        onProgress(percent);
      }
    });
  }
}
